import { render, staticRenderFns } from "./CargoColegiado.vue?vue&type=template&id=8a3441fa&scoped=true&"
import script from "./CargoColegiado.vue?vue&type=script&lang=js&"
export * from "./CargoColegiado.vue?vue&type=script&lang=js&"
import style0 from "./CargoColegiado.vue?vue&type=style&index=0&id=8a3441fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3441fa",
  null
  
)

export default component.exports